import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import type {EntityCardSkeletonProps} from './entity-card-skeleton.types';
import {parseSkeletonMode} from '@Components/ai-chat-window/lib/skeleton.library';
import {EntityCardSkeleton} from './entity-card-skeleton';

export const entityCardSkeletonRegistration = defineStreamComponentRegistration(
  StreamComponentType.ENTITY_CARD_SKELETON,
  EntityCardSkeleton,
  (props: Record<string, unknown>): EntityCardSkeletonProps => ({
    mode: parseSkeletonMode(props.mode),
  })
);
